import UserManagement from "./UserManagement";
import { useState } from "react";

function Settings() {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <div className="settings-page">
      <div className="settings-header">
        <div className="title-area">
          <h3>
            <span className="icon">⚙️</span> Settings
          </h3>
          <p>
            Manage your account settings, user permissions, and system
            configurations.
          </p>
        </div>
      </div>

      <div className="settings-tabs-container">
        <div className="tabs">
          {/* Comment for the future scope */}
          {/* <button
            className={`tab ${activeTab === "users" ? "active" : ""}`}
            onClick={() => setActiveTab("users")}
          >
            User Management
          </button> */}
          {/* <button
            className={`tab ${activeTab === "general" ? "active" : ""}`}
            onClick={() => setActiveTab("general")}
          >
            General
          </button> */}
        </div>
      </div>

      <div className="settings-content">
        {activeTab === "users" && (
          <div className="settings-container-placeholder">
            <UserManagement />
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;
